import React from 'react';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { StatsDiv } from '../component/stats/StatsDiv';
import { GeneralPageLayout } from '../layout/GeneralPageLayout';

export const StatsPage = () => (
  <GeneralPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<StatsDiv />}
  />
);
